import styled, { css } from 'styled-components';

import { CommonTheme } from 'app/shared/theme';
import {
  withBackgroundCSS,
  WithBackgroundProps,
  withCursorCSS,
  WithCursorProps,
  withDimensionsCSS,
  WithDimensionsProps,
  withGridCSS,
  WithGridProps,
  withSpacingCSS,
  WithSpacingProps,
} from 'app/shared/components/styleUtils';

export { GridItem, type GridItemProps } from './GridItem';

export interface GridProps
  extends WithSpacingProps,
    WithDimensionsProps,
    WithCursorProps,
    WithGridProps,
    WithBackgroundProps {}

interface GridCSSProps extends GridProps {
  theme: CommonTheme;
}

export const Grid = styled.div<GridCSSProps>`
  ${({ numberOfColumns = 12, gap = 2, ...props }) => css`
    ${withGridCSS({ numberOfColumns, gap, ...props })};
  `}

  ${withSpacingCSS};
  ${withBackgroundCSS};
  ${withDimensionsCSS};
  ${withCursorCSS};
`;
